import { useEffect, useCallback } from 'react';
import useSocket from './useSocket';

export default function useSocketEvent(resource, action, callback) {
  const { socket, connectionState } = useSocket();
  const isConnected = connectionState.status === 'connected';

  // Wrap the callback to ensure consistent reference
  const stableCallback = useCallback((data) => {
    callback(data);
  }, [callback]);

  useEffect(() => {
    if (!isConnected || !resource || !action || !callback) return;

    // Register the event listener
    const unsubscribe = socket.listenToEvent(resource, action, stableCallback);

    // Cleanup: remove the event listener
    return unsubscribe;
  }, [socket, isConnected, resource, action, stableCallback]);
}
